import VueLodash from 'vue-lodash'
import lodash from 'lodash'

export default {
    install(Vue, options) {
        Vue.use(VueLodash, { name: 'custom' , lodash: lodash })
    }
}